import {Injectable, Injector} from '@angular/core';
import {Principal} from 'app/core/auth/principal.service';
import {AuthServerProvider} from 'app/core/auth/auth-jwt.service';
import {Store} from '@ngxs/store';
import {LogoutUser} from 'app/blocks/store/actions/logout-reducer';
import {FilterSettingService} from 'app/blocks/service/api/filter-setting.service';
import {SuperUserService} from 'app/core/auth/super-user.service';
import {AssistantContextService} from 'app/blocks/service/assistant-context/assistant-context.service';
import {onAssistantLogout} from 'app/layout/components/hauliermagic-assistant-chat/hauliermagic-assistant-storage';

@Injectable()
export class LoginService {
    isSuperuser = false;
    constructor(
        // private languageService: JhiLanguageService,
        private principal: Principal,
        private authServerProvider: AuthServerProvider,
        private _store: Store,
        private filterService: FilterSettingService,
        private superUserService: SuperUserService,
        private injector: Injector
    ) {
        this.isSuperuser = this.superUserService.getIsSuperUser();
    }

    login(credentials, callback?): Promise<any> {
        const cb = callback || (() => {});

        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe(
                (data) => {
                    this.principal.identity(true).then((account) => {
                        // After the login the language will be changed to
                        // the language selected by the user during his registration
                        // if (account !== null) {
                        // this.languageService.changeLanguage(account.langKey);
                        // }
                        if (!this.isSuperuser) {
                            this.filterService.resetDateFilters(account.id);
                        }
                        resolve(data);
                    });
                    return cb();
                },
                (err) => {
                    this.logout(false, false);
                    reject(err);
                    return cb(err);
                }
            );
        });
    }

    loginWithToken(jwt, rememberMe): Promise<any> {
        return this.authServerProvider.loginWithToken(jwt, rememberMe);
    }

    /**
     * @param reload go back to the login page
     * @param clearAssistantChats wipe the stored assistant chats of this browser: only for a real sign-out; a failed login or an
     *        expired session keeps them (the keys are per user, so nobody else sees them) so unsynced edits are not lost
     */
    logout(reload = false, clearAssistantChats = true): void {
        this.authServerProvider.logout().subscribe();
        this.principal.authenticate(null);
        this._store.dispatch(new LogoutUser());
        this.superUserService.setIsSuperUser(false);
        this.superUserService.setDifferentUser(null);
        // RMA-12: the next person to sign in on this browser must not see (or upload) this user's assistant chats
        onAssistantLogout(clearAssistantChats);
        // RMA-34: forget the previous user's screen context (trail, errors, failed calls); reset() ships with the context service
        try {
            const context: any = this.injector.get(AssistantContextService);
            if (typeof context.reset === 'function') {
                context.reset();
            }
        } catch (e) {
            // context service unavailable: nothing to reset
        }
        if (reload) {
            window.location.href = '/login';
        }
    }

    createAccount(credentials, callback?): Promise<any> {
        return this.authServerProvider.create(credentials).toPromise();
    }
}
